<!-- 实名认证 -->
<template>
  <div class="phone-container" v-loading="loading" v-if="!enterprisesShow">
    <!-- <img
        src="https://www.renrenxiaoka.com/_nuxt/auth-banner.CfiEZzMK.png"
        alt=""
        style=" width: 670px; height: 117px"
      /> -->
    <!-- <div
      class="item-view"
      style="margin-top: 20px; padding: 0px 20px; height: 117px"
    >
      <div class="item-left">
        <img src="@/assets/image/renzheng1.png" alt="" />
        <div class="item-content">
          <div class="item">
            <div class="media">企业认证</div>
            <img src="@/assets/image/下载 (4).png" alt="" />
            <div class="recom-tag">推荐</div>
          </div>
          <div class="item-centre" style="padding: 10px 0px">
            企业认证可提高每日销卡额度；
          </div>
          <div class="item-centre">如有疑问，请咨询客服</div>
        </div>
      </div>
    </div> -->
    <div class="item-view"
      style="margin-top: 30px; padding: 10px 20px;display: flex;flex-direction: column; justify-content: center;">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div class="item-left">
          <img src="@/assets/newImage/位图@2x.png" style="width: 120px; height: 120px;" />
          <div class="item-content">
            <div class="item" style="margin-top: 21px;">
              <div class="media">个人认证</div>
            </div>
            <div class="item-centre" style="margin-top: 15px;" v-if="pageData.credentialLevel==0">
              您还没初级认证，认证后可销卡和提现
            </div>
            <div class="item-centre" style="margin-top: 15px;" v-else-if="pageData.credentialLevel==1">
              完成高级认证，可提升每日销卡额度
            </div>
            <div class="item-centre" style="margin-top: 10px;"  v-if="pageData.credentialLevel!=0">
              <span style="width: 87px;flex-shrink: 0;">真实姓名:</span>
              <span style="font-size: 14px; color: black;">{{ pageData.name }}</span>
            </div>
            <!-- <div class="item-centre" v-if="pageData.credentialLevel!=2">如有疑问，请咨询客服</div> -->
            <div class="item-centre" v-if="pageData.credentialLevel!=0" style="padding:10px 0px;">
              <span style="width: 87px; flex-shrink: 0;">证件号码:</span>
              <span style="font-size: 14px; color: black;">{{ pageData.idNum }}</span>

            </div>
            <div style="
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
          " v-if="pageData.credentialLevel !=0">
              您当前已签署承诺书
              <div
                style="margin-top: 10px; color: rgb(72, 142, 255); font-size: 14px; margin-top: 11px;    text-decoration: underline;"
                @click="contractImg">
                查看电子合同
              </div>
            </div>
          </div>
        </div>
        <div class="flex-row-ct" style="height: 100%; width: 100px"
          v-if="pageData.credentialLevel!=2">
          <el-button type="primary" @click="dialogClick">{{
            pageData.credentialLevel==0 ? "初级认证" : "高级认证" }}</el-button>
        </div>
        <img src="@/assets/newImage/编组@2x.png" alt="" v-else style="width: 124px; height: 108px;">
      </div>

    </div>
    <div class="item-view"
         style="margin-top: 30px; padding: 10px 20px;display: flex;flex-direction: column; justify-content: center;">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div class="item-left">
          <img src="@/assets/newImage/位图@2x.png" style="width: 120px; height: 120px;" />
          <div class="item-content">
            <div class="item" style="margin-top: 21px;">
              <div class="media">企业认证</div>
            </div>
            <div class="item-centre" style="margin-top: 15px;" v-if="pageData.enterpriseStatus==0">
              升级企业认证提升核销金额50万
            </div>
            <div class="item-centre" style="margin-top: 15px;" v-if="pageData.enterpriseStatus==0">
              可独立配置核销费率
            </div>
            <div class="item-centre" style="margin-top: 15px;" v-if="pageData.enterpriseStatus==3">
              失败原因：{{pageData.notes}}
            </div>
            <div class="item-centre" style="margin-top: 10px;"  v-if="pageData.enterpriseStatus==1 || pageData.enterpriseStatus == 2">
              <span style="font-size: 14px; color: black;">{{ pageData.company }}</span>
            </div>
            <div class="item-centre" v-if="pageData.enterpriseStatus==1 || pageData.enterpriseStatus == 2" style="padding:10px 0px;">
              <span style="font-size: 14px; color: black;">{{ pageData.regnum }}</span>
            </div>
            <div style="
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
          " v-if="pageData.enterpriseStatus == 2 && pageData.enterpriseContractStatus == 1">
              <div
                  style="margin-top: 10px; color: rgb(72, 142, 255); font-size: 14px; margin-top: 11px;    text-decoration: underline;"
                  @click="enterprisesContractImg">
                查看电子合同
              </div>
            </div>
          </div>
        </div>
        <div class="flex-row-ct" style="height: 100%; width: 100px"
             v-if="pageData.enterpriseStatus == 0">
          <el-button type="primary" @click="dialogEnterprisesClick">开始认证</el-button>
        </div>
        <div class="flex-row-ct" style="height: 100%; width: 100px"
             v-else-if="pageData.enterpriseStatus == 1">
          <el-button type="primary">审核中</el-button>
        </div>
        <div class="flex-row-ct" style="height: 100%; width: 100px"
             v-else-if="pageData.enterpriseStatus == 3">
          <el-button type="primary" @click="dialogEnterprisesClick">重新认证</el-button>
        </div>
        <div class="flex-row-ct" style="height: 100%; width: 100px"
             v-else-if="pageData.enterpriseStatus == 2 && pageData.enterpriseContractStatus == 0">
          <el-button type="primary" @click="enterprisesPrint">去签署</el-button>
        </div>
        <img src="@/assets/newImage/已认证@2x.png" alt="" v-else-if="pageData.enterpriseContractStatus == 1" style="width: 124px; height: 108px;">
      </div>

    </div>
    <!-- <div
      class="item-view"
      style="margin-top: 20px; padding: 0px 20px; height: 117px"
    >
      <div class="item-left">
        <img src="@/assets/image/renzheng1.png" alt="" />
        <div class="item-content">
          <div class="item">
            <div class="media">尽职调查</div>
            <img src="@/assets/image/下载 (4).png" alt="" />
            <div class="recom-tag">推荐</div>
          </div>
          <div class="item-centre" style="padding: 10px 0px">
            完成尽职调查，每日销卡额度可增加1000000元
          </div>
          <div class="item-centre">如有疑问，请咨询客服</div>
        </div>
      </div>
    </div> -->
    <!-- 实名认证 -->
    <el-dialog title="支付宝扫码认证" :visible.sync="dialogVisible" width="300px">
      <vue-qr :text="qrCodeValue" :size="250"></vue-qr>
      <div slot="footer" class="dialog-footer" style="width: 100%; display: flex; justify-content: center">
        <div style="
            width: 85%;
            height: 50px;
            background-color: #2d6df6;
            border-radius: 5px;
            color: white;
            line-height: 50px;
            text-align: center;
          " @click="refresh">
          我已经完成认证
        </div>
      </div>
    </el-dialog>
    <!-- 查看电子合同 -->
    <el-dialog title="查看电子合同" :visible.sync="dialogContract" width="700px" height="500px">
      <el-image style="width: 100%; height: 100%" :src="imgUrl" :fit="fit"></el-image>
    </el-dialog>
    <!-- 初级认证 -->
    <div class="primary-container" v-if="dialogPrimary">
      <div class="primary-content">
        <img src="@/assets/newImage/初级认证.png" alt="">
        <!-- 右上角关闭 -->
        <div class="close-container" @click="dialogPrimary = false">
        </div>
        <!-- 底部内容 -->
        <div class="primary-bottom">
          <!-- 提示 -->
          <div class="primary-bottom-tip">
            为有效保障您的合法权益和领点回收正常合法经营需实名认证并签署承诺书，才能使用领点回收回收服务及提现操作，请您仔细阅读并签署！
          </div>
          <!-- 输入提示 -->
          <div class="primary-bottom-input">请输入与您的提现账号一致的实名姓名和身份证号码 </div>
          <!-- 输入框 -->
          <div class="primary-bottom-input-box">
            <el-input v-model="name" placeholder="请输入姓名"></el-input>
            <!-- <input type="text" placeholder="请输入姓名"> -->
            <el-input v-model="idNum" placeholder="请输入身份证号码" style="margin-top: 10px;"></el-input>
          </div>
          <!-- 按钮 -->
          <div class="primary-bottom-button">
            <el-button type="primary" @click="primarySubmit">立即签署</el-button>
          </div>
        </div>
      </div>
    </div>
  </div  >
  <div class="phone-container enterprises-container" v-loading="loading" v-else-if="enterprisesShow">
      <el-form :model="enterprisesData" label-width="140px" rules="enterprisesFormRules" label-position="left">
<!--        <el-form-item label="营业执照">-->
<!--            <el-upload-->
<!--                class="avatar-uploader"-->
<!--                action=""-->
<!--                :show-file-list="false"-->
<!--                :on-success="handleAvatarSuccess"-->
<!--                :before-upload="beforeAvatarUpload">-->
<!--              <img v-if="imageUrl" :src="imageUrl" class="avatar">-->
<!--              <img v-else src="@/assets/newImage/编组 13@2x.png" class="avatar-uploader-icon">-->
<!--            </el-upload>-->
<!--        </el-form-item>-->
        <el-form-item label="法人姓名">
          <el-input v-model="pageData.name" placeholder="请输入法人姓名" disabled></el-input>
        </el-form-item>
        <el-form-item label="法人证件号">
          <el-input v-model="pageData.idNum" placeholder="请输入法人证件号" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="enterprisesData.company" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码">
          <el-input v-model="enterprisesData.regnum" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="法人电话">
          <el-input v-model="enterprisesData.mobile" placeholder="请输入公司电话"></el-input>
        </el-form-item>
        <el-form-item label="公司邮箱">
          <el-input v-model="enterprisesData.email" placeholder="请输入公司邮箱"></el-input>
        </el-form-item>
        <el-form-item label="公司地址">
          <el-input v-model="enterprisesData.addr" placeholder="请输入公司地址"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="enterprisesSubmit">提交认证</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import http from "@/utils/http/axios";
import axios from "axios";
import Cokie from "js-cookie";
export default {
  components: {
    vueQr,
  },

  data() {
    return {
      imgUrl: '',
      qrCodeValue: "",
      dialogVisible: false,
      dialogPrimary: false,
      loading: false,
      pageData: undefined,
      dialogContract: false,
      name: '',
      idNum: '',
      enterprisesShow: false, // 企业认证弹窗
      imageUrl: '', // 企业认证营业执照图片
      enterprisesData: {
        company: '',  // 公司名称
        regnum: '', // 社会统一信用代码
        addr: '', // 公司地址
        mobile: '', // 公司电话
        email: ''  // 公司邮箱
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    // 打开弹窗生成实名认证二维码
    dialogClick() {
      if(this.pageData.credentialLevel==0){
        this.dialogPrimary = true;
      }else{
        this.print();
      }

      // if (!this.pageData.isRealName) {
      //   this.print();
      // } else {
      //   this.facePrint();
      // }
    },
    //刷新认证
    refresh() {
      this.getUserInfo();
      this.dialogVisible = false;
    },
    // 用户信息
    getUserInfo() {
      this.loading = true;
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.pageData = response.data;
            this.loading = false;

          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    // 初级认证提交
    primarySubmit(){
      if(!this.name || !this.idNum){
        this.$message.error("请输入姓名和身份证号码");
        return;
      }
      this.dialogPrimary = false;
     this.facePrint()

    },

    //  获取二维码
    print() {
      this.loading = true;
      http
        .get("/user/face/print")
        .then((response) => {
          console.log("Response Data:", response); // 调试日志
          if (response.code === 200) {
            this.qrCodeValue = response.data;
            this.dialogVisible = true;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    //承诺书签署链接
    facePrint() {
      this.loading = true;
      http
        .get("/user/contract/signUrl?platform=3&name="+this.name+"&idNum="+this.idNum)
        .then((response) => {
          this.qrCodeValue = response.data;
          this.dialogVisible = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    // 个人 查看电子合同
    contractImg() {
      this.loading = true;
      http
        .get("/user/contract/img")
        .then((response) => {
          if (response.code == 200 && response.data) {
            this.imgUrl = "data:image/jpeg;base64," + response.data;
            this.dialogContract = true;
          }else {
            this.$message.error("未找到电子合同");
          }
          this.loading = false;

        })
        .catch(() => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    // 企业认证
    dialogEnterprisesClick(){
      if(this.pageData.credentialLevel < 2){
        this.$message.error("请先完成个人认证");
        return;
      }
      this.enterprisesShow = true;
    },
    // 上传营业执照前的验证
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传营业执照成功后的处理
    handleAvatarSuccess(response, file) {
      if (response.code === 200) {
        this.imageUrl = response.data;
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败: " + response.msg);
      }
    },
    // 企业认证提交
    enterprisesSubmit() {
      if (!this.enterprisesData.company || !this.enterprisesData.regnum || !this.enterprisesData.addr || !this.enterprisesData.mobile || !this.enterprisesData.email) {
        this.$message.error("请填写完整的企业信息");
        return;
      }
      this.loading = true;
      http.post("/user/enterprise", this.enterprisesData)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success("企业认证提交成功");
            this.loading = false;
            this.enterprisesShow = false;
            this.getUserInfo();
          } else {
            this.$message.error(response.msg);
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    // 企业认证 去签署 获取二维码
    enterprisesPrint() {
      this.loading = true;
      http
        .get("/user/contract/enterprise/signUrl")
        .then((response) => {
          if (response.code === 200) {
            this.qrCodeValue = response.data;
            this.dialogVisible = true;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },
    // 企业 查看电子合同
    enterprisesContractImg() {
      this.loading = true;
      http
        .get("/user/enterprise/info")
        .then((response) => {
          if (response.code == 200 && response.data.contractImg) {
            this.imgUrl = "data:image/jpeg;base64," + response.data.contractImg;
            this.dialogContract = true;
          }else {
            this.$message.error("未找到电子合同");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("发生意外异常");
        });
    },




  },
};
</script>

<style lang="scss" scoped>
.phone-container {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 30px;
  position: relative;

  .primary-container {
    //灰色透明
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    .primary-content{
      width: 600px;
      height: 420px;
      border-radius: 20rpx;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        border-radius: 20rpx;
      }
      .close-container{
        position: absolute;
        top: 0px;
        right: 0px;
        height: 80px;
        width: 80px;
        text-align: center;
        line-height: 80px;
        color: black;
        font-size: 20px;
        font-weight: 700;
      }
      .primary-bottom{
        position: absolute;
        top: 150px;
        left: 0px;
        width: 100%;
        display: flex;
        // align-items: center;
        flex-direction: column;
        justify-content: center;
        padding: 0px 75px;
        .primary-bottom-tip{
          font-size: 14px;
          color: #000000;
          line-height: 22px;
        }
        .primary-bottom-input{
          margin-top: 22px;
          color: #4D7EF4;
          font-size: 14px;
        }
        .primary-bottom-input-box{
          width: 100%;
          margin-top: 22px;
          display: flex;
          flex-direction: column;
        }
        .primary-bottom-button{
          margin-top: 22px;
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  .item-view {
    display: flex;
    align-content: center;
    justify-content: space-between;
    background: linear-gradient(180deg, #DCF4FF 0%, #FFFFFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(162, 162, 162, 0.5);
    border-radius: 4px;
    width: 670px;
    box-sizing: border-box;

    .recom-tag {
      display: inline-flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: center;
      background: rgb(255, 66, 21);
      border-radius: 7px 7px 7px 0px;
      color: rgb(255, 255, 255);
      font-family: "PingFang SC";
      font-size: 11px;
      font-weight: 500;
      height: 17px;
      justify-content: center;
      margin-left: 8px;
      width: 34px;
    }
  }

  .bg-view {
    width: 100%;
    height: 117px;
  }

  .item-left {
    display: flex;
    align-items: center;

    img {
      height: 80px;
      width: 80px;
    }

    .item-content {
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      padding: 0px 30px;

      .item {
        display: flex;
        align-items: center;

        .media {
          font-size: 20px;
          font-weight: 700;
          color: rgba(0, 0, 0, 0.88);
        }

        img {
          width: 20px;
          height: 20px;
          margin: 0px 10px;
        }
      }

      .item-centre {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        display: flex;
        align-items: center;
      }
    }
  }
}

/* // 模态框居中 */
.el-dialog__wrapper {
  text-align: center;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 0px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
  }

}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 419px;
  height: 232px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.license-upload-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  .license-title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 10px;
  }
}

/* 企业认证表单容器样式 */
.enterprises-container {
  align-items: flex-start !important;
  padding-left: 60px; /* 添加左边距，使表单整体向右移动 */

  .el-form {
    width: 670px;
  }
}
</style>
